{{#if preview}}
  {{#if template_option}}
    <em>This is a hidden field that will mark this lead as <strong>{{ template_option }}</strong> in Salesforce.</em>
  {{else}}
    <em>Edit this field to select a Lead Status.</em>
  {{/if}}
{{else}}
  <input type="hidden" name="{{prefix}}[lead_status]" value="{{ template_option }}">
{{/if}}
